import React from "react";
import { UseFormRegisterReturn, FieldError } from "react-hook-form";

export interface InputProps {
  label?: string;
  placeholder?: string;
  type?: "text" | "email" | "password" | "number" | "tel" | "url";
  icon?: string;
  iconAlt?: string;
  register?: UseFormRegisterReturn;
  error?: FieldError;
  isSubmitted?: boolean;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  inputMode?: "text" | "email" | "numeric" | "tel" | "url";
  pattern?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const Input: React.FC<InputProps> = ({
  label,
  placeholder,
  type = "text",
  icon,
  iconAlt,
  register,
  error,
  required = false,
  disabled = false,
  className = "",
  inputMode,
  pattern,
  value,
  onChange,
}) => {
  const inputClass = icon ? "form-input-with-icon" : "form-input";

  return (
    <div>
      {label && (
        <label className="form-label">
          {label} {required && <span className="form-label-required">*</span>}
        </label>
      )}
      <div className="input-container">
        {icon && (
          <span className="input-icon">
            <img src={icon} alt={iconAlt || "Icon"} className="w-5 h-5" />
          </span>
        )}
        <input
          {...register}
          type={type}
          placeholder={placeholder}
          className={`${inputClass} ${className}`}
          disabled={disabled}
          inputMode={inputMode}
          pattern={pattern}
          value={value}
          onChange={onChange}
        />
      </div>
      {error && <p className="form-error">{error.message}</p>}
    </div>
  );
};

export default Input;
